"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuxiliaryData = void 0;
var cbor_1 = require("@harmoniclabs/cbor");
var crypto_1 = require("@harmoniclabs/crypto");
var hashes_1 = require("../../hashes/index.js");
var NativeScript_1 = require("../../script/NativeScript.js");
var Script_1 = require("../../script/Script.js");
var metadata_1 = require("../metadata/index.js");
var obj_utils_1 = require("@harmoniclabs/obj-utils");
var assert_1 = require("../../utils/assert.js");
var InvalidCborFormatError_1 = require("../../utils/InvalidCborFormatError.js");
function scriptArrToCbor(scripts) {
    return new cbor_1.CborArray(scripts.map(function (script) { return new cbor_1.CborBytes(script.bytes); }));
}
var AuxiliaryData = /** @class */ (function () {
    function AuxiliaryData(auxData) {
        var _this = this;
        (0, assert_1.assert)((0, obj_utils_1.hasOwn)(auxData, "metadata"), "'AuxiliaryData' is missing 'metadata' field");
        var metadata = auxData.metadata, nativeScripts = auxData.nativeScripts, plutusV1Scripts = auxData.plutusV1Scripts, plutusV2Scripts = auxData.plutusV2Scripts;
        // -------------------------------- native scripts -------------------------------- //
        (0, assert_1.assert)(metadata === undefined || metadata instanceof metadata_1.TxMetadata, "'AuxiliaryData' :: 'metadata' field was not instance of 'TxMetadata'");
        (0, obj_utils_1.defineReadOnlyProperty)(this, "metadata", metadata);
        // -------------------------------- native scripts -------------------------------- //
        if (nativeScripts !== undefined) {
            (0, assert_1.assert)(Array.isArray(nativeScripts) &&
                nativeScripts.every(function (script) {
                    return true;
                }), "invalid nativeScripts field");
            (0, obj_utils_1.defineReadOnlyProperty)(this, "nativeScripts", nativeScripts.length === 0 ? undefined : Object.freeze(nativeScripts));
        }
        else {
            (0, obj_utils_1.defineReadOnlyProperty)(this, "nativeScripts", undefined);
        }
        // -------------------------------- plutus v1 -------------------------------- //
        if (plutusV1Scripts !== undefined) {
            (0, assert_1.assert)(Array.isArray(plutusV1Scripts) &&
                plutusV1Scripts.every(function (script) {
                    return true;
                }), "invalid plutusV1Scripts field");
            (0, obj_utils_1.defineReadOnlyProperty)(this, "plutusV1Scripts", plutusV1Scripts.length === 0 ? undefined : Object.freeze(plutusV1Scripts));
        }
        else {
            (0, obj_utils_1.defineReadOnlyProperty)(this, "plutusV1Scripts", undefined);
        }
        // -------------------------------- plutus v2 -------------------------------- //
        if (plutusV2Scripts !== undefined) {
            (0, assert_1.assert)(Array.isArray(plutusV2Scripts) &&
                plutusV2Scripts.every(function (script) {
                    return true;
                }), "invalid plutusV2Scripts field");
            (0, obj_utils_1.defineReadOnlyProperty)(this, "plutusV2Scripts", plutusV2Scripts.length === 0 ? undefined : Object.freeze(plutusV2Scripts));
        }
        else {
            (0, obj_utils_1.defineReadOnlyProperty)(this, "plutusV2Scripts", undefined);
        }
        // --------- hash ---- //
        var _hash = undefined;
        (0, obj_utils_1.definePropertyIfNotPresent)(this, "hash", {
            get: function () {
                if (_hash instanceof hashes_1.AuxiliaryDataHash)
                    return _hash.clone();
                _hash = new hashes_1.AuxiliaryDataHash(new Uint8Array((0, crypto_1.blake2b_256)(_this.toCbor().toBuffer())));
                return _hash.clone();
            },
            set: function () { },
            enumerable: true,
            configurable: false
        });
    }
    AuxiliaryData.prototype.toCbor = function () {
        return cbor_1.Cbor.encode(this.toCborObj());
    };
    AuxiliaryData.prototype.toCborObj = function () {
        return new cbor_1.CborTag(259, new cbor_1.CborMap([
            this.metadata === undefined ? undefined :
                {
                    k: new cbor_1.CborUInt(0),
                    v: this.metadata.toCborObj()
                },
            this.nativeScripts === undefined || this.nativeScripts.length === 0 ? undefined :
                {
                    k: new cbor_1.CborUInt(1),
                    v: scriptArrToCbor(this.nativeScripts)
                },
            this.plutusV1Scripts === undefined || this.plutusV1Scripts.length === 0 ? undefined :
                {
                    k: new cbor_1.CborUInt(2),
                    v: scriptArrToCbor(this.plutusV1Scripts)
                },
            this.plutusV2Scripts === undefined || this.plutusV2Scripts.length === 0 ? undefined :
                {
                    k: new cbor_1.CborUInt(3),
                    v: scriptArrToCbor(this.plutusV2Scripts)
                }
        ].filter(function (elem) { return elem !== undefined; })));
    };
    AuxiliaryData.fromCbor = function (cStr) {
        return AuxiliaryData.fromCborObj(cbor_1.Cbor.parse((0, cbor_1.forceCborString)(cStr)));
    };
    AuxiliaryData.fromCborObj = function (cObj) {
        var _a;
        // shelley; metadata only
        if (cObj instanceof cbor_1.CborMap) {
            return new AuxiliaryData({
                metadata: metadata_1.TxMetadata.fromCborObj(cObj)
            });
        }
        // shelley multi assets; metadata + native scripts
        if (cObj instanceof cbor_1.CborArray) {
            if (!(cObj.array[1] instanceof cbor_1.CborArray))
                throw new InvalidCborFormatError_1.InvalidCborFormatError("AuxiliaryData");
            return new AuxiliaryData({
                metadata: metadata_1.TxMetadata.fromCborObj(cObj.array[0]),
                nativeScripts: cObj.array[1].array.map(NativeScript_1.nativeScriptFromCborObj)
            });
        }
        if (!(cObj instanceof cbor_1.CborTag &&
            cObj.data instanceof cbor_1.CborMap))
            throw new InvalidCborFormatError_1.InvalidCborFormatError("AuxiliaryData");
        var fields = new Array(4).fill(undefined);
        var _loop_1 = function (i) {
            var v = ((_a = cObj.data.map.find(function (_a) {
                var k = _a.k;
                return k instanceof cbor_1.CborUInt && Number(k.num) === i;
            })) !== null && _a !== void 0 ? _a : { v: undefined }).v;
            if (v === undefined)
                return "continue";
            fields[i] = v;
        };
        for (var i = 0; i < 4; i++) {
            _loop_1(i);
        }
        var _b = __read(fields, 4), _metadata = _b[0], _native = _b[1], _pV1 = _b[2], _pV2 = _b[3];
        if (!(_native instanceof cbor_1.CborArray &&
            _pV1 instanceof cbor_1.CborArray &&
            _pV2 instanceof cbor_1.CborArray))
            throw new InvalidCborFormatError_1.InvalidCborFormatError("AuxiliaryData");
        return new AuxiliaryData({
            metadata: _metadata === undefined ? undefined : metadata_1.TxMetadata.fromCborObj(_metadata),
            nativeScripts: _native === undefined ? undefined :
                _native.array.map(function (nativeCborObj) {
                    return new Script_1.Script(Script_1.ScriptType.NativeScript, cbor_1.Cbor.encode(nativeCborObj).toBuffer());
                }),
            plutusV1Scripts: _pV1 === undefined ? undefined :
                _pV1.array.map(function (cbor) {
                    return new Script_1.Script(Script_1.ScriptType.PlutusV1, cbor_1.Cbor.encode(cbor).toBuffer());
                }),
            plutusV2Scripts: _pV2 === undefined ? undefined :
                _pV2.array.map(function (cbor) {
                    return new Script_1.Script(Script_1.ScriptType.PlutusV2, cbor_1.Cbor.encode(cbor).toBuffer());
                })
        });
    };
    AuxiliaryData.prototype.toJson = function () {
        var _a, _b, _c, _d;
        return {
            metadata: (_a = this.metadata) === null || _a === void 0 ? void 0 : _a.toJson(),
            nativeScripts: (_b = this.nativeScripts) === null || _b === void 0 ? void 0 : _b.map(function (s) { return s.toJson(); }),
            plutusV1Scripts: (_c = this.plutusV1Scripts) === null || _c === void 0 ? void 0 : _c.map(function (s) { return s.toJson(); }),
            plutusV2Scripts: (_d = this.plutusV2Scripts) === null || _d === void 0 ? void 0 : _d.map(function (s) { return s.toJson(); }),
        };
    };
    return AuxiliaryData;
}());
exports.AuxiliaryData = AuxiliaryData;
